import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import authService from '../../../../services/auth.service';
import Swal from 'sweetalert2';
import './Auth.css'; // Assuming common auth styles or creating new one

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('verifying'); // verifying, success, error

    useEffect(() => {
        const verify = async () => {
            const codigo = searchParams.get('codigo');
            const email = searchParams.get('email');

            if (!codigo || !email) {
                setStatus('error');
                Swal.fire('Error', 'Enlace de verificación inválido (faltan datos).', 'error');
                return;
            }

            try {
                // Send 'codigo' to match backend expectation
                await authService.verifyEmail({ codigo, email });
                setStatus('success');
                Swal.fire({
                    title: '¡Verificado!',
                    text: 'Tu correo ha sido verificado exitosamente. Ahora puedes iniciar sesión.',
                    icon: 'success',
                    confirmButtonText: 'Ir al Login'
                }).then(() => {
                    navigate('/login');
                });
            } catch (error) {
                setStatus('error');
                console.error(error);
                Swal.fire('Error', error.response?.data?.detail || 'No se pudo verificar el correo.', 'error');
            }
        };

        verify();
    }, [searchParams, navigate]);

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2>Verificación de Cuenta</h2>
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    {status === 'verifying' && (
                        <div>
                            <div className="spinner"></div>
                            <p>Verificando tu correo...</p>
                        </div>
                    )}
                    {status === 'success' && (
                        <div style={{ color: 'var(--success-green)' }}>
                            <p>¡Cuenta verificada correctamente!</p>
                            <button className="btn-custom btn-primary" onClick={() => navigate('/login')}>Ir al Login</button>
                        </div>
                    )}
                    {status === 'error' && (
                        <div style={{ color: 'var(--danger-red)' }}>
                            <p>Hubo un problema al verificar tu cuenta.</p>
                            <button className="btn-custom btn-secondary" onClick={() => navigate('/login')}>Volver al inicio</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;
